import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Notifications',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
